export default __webpack_public_path__ + "static/media/Visa.ccc21e73.svg";